/* import __COLOCATED_TEMPLATE__ from './email.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { validEmail } from '@square/ember-multipass-components/utils/ember-multipass-email-util';
import { setInputAutocomplete, setInputEnterKeyHint, setInputEnterListener, updateError, focus } from '@square/ember-multipass-components/utils/ember-multipass-input-util';
let SecureContactModalEnrollEmailComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class SecureContactModalEnrollEmailComponent extends Component {
  get canRequestEmailCode() {
    return this.emailError === undefined;
  }
  get invalidEmailErrorTLabel() {
    return 'secure_contact_modals.enroll.email.errors.invalid_email';
  }
  get presenceEmailErrorTLabel() {
    return 'secure_contact_modals.enroll.email.errors.presence_email';
  }
  get secureContactAliasConflictErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.secure_contact_alias_conflict';
  }
  get temporaryLockoutErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.temporary_lockout';
  }
  get unknownErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.unknown';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor3, this);
    _initializerDefineProperty(this, "loading", _descriptor4, this);
    _defineProperty(this, "email", '');
    _initializerDefineProperty(this, "emailError", _descriptor5, this);
    _defineProperty(this, "emailInput", void 0);
    _defineProperty(this, "validating", false);
    this.initializeAccountInformation();
  }
  async initializeAccountInformation() {
    if (this.multipassfeClient.accountInformation === undefined) {
      await this.multipassfeClient.getAccountInformation();
    }
  }
  updateEmailError() {
    if (this.email.length === 0) {
      this.emailError = this.intl.t(this.args.tPrefix + this.presenceEmailErrorTLabel);
      updateError(this.emailInput, 'email-error');
    } else if (!validEmail(this.email)) {
      this.emailError = this.intl.t(this.args.tPrefix + this.invalidEmailErrorTLabel);
      updateError(this.emailInput, 'email-error');
    } else if (this.emailError) {
      this.emailError = undefined;
      updateError(this.emailInput);
    }
  }
  updateEmail(event) {
    const target = event.detail || event.target;
    this.email = target.value;
    if (this.validating) {
      this.updateEmailError();
    }
  }
  initializeEmailInput(event) {
    const {
      input
    } = event.detail;
    this.emailInput = input;
    focus(input);
    setInputEnterListener(input, this.sendEmailSecureContactCodeDebounced);
    setInputEnterKeyHint(input, 'go');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
    setInputAutocomplete(input, 'username');
  }
  handleMultipassError(error) {
    switch (error) {
      case 'TEMPORARY_LOCKOUT':
        this.emailError = this.intl.t(this.args.tPrefix + this.temporaryLockoutErrorTLabel);
        break;
      default:
        this.emailError = this.intl.t(this.args.tPrefix + this.unknownErrorTLabel);
    }
  }
  async sendEmailSecureContactCodeDebounced() {
    debounce(this, this.sendEmailSecureContactCode, 500, true);
  }
  async sendEmailSecureContactCode() {
    this.validating = true;
    this.updateEmailError();
    if (this.emailError) {
      return;
    }
    await this.initializeAccountInformation();
    if (this.multipassfeClient.accountInformation?.email_address === this.email) {
      this.emailError = this.intl.t(this.args.tPrefix + this.secureContactAliasConflictErrorTLabel);
      updateError(this.emailInput, 'email-error');
      return;
    }
    if (!this.canRequestEmailCode) {
      this.emailError = this.intl.t(this.args.tPrefix + this.invalidEmailErrorTLabel);
      updateError(this.emailInput, 'email-error');
      return;
    }
    try {
      this.args.setEmail(this.email);
      this.validating = true;
      this.loading = true;
      await this.multipassfeClient.sendEmailSecureContactCode(this.email);
      this.args.next();
    } catch (e) {
      this.logger.error('Error enrolling secure contact email', e.message);
      this.handleMultipassError(e.message);
    } finally {
      this.loading = false;
      this.validating = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "emailError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "updateEmail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeEmailInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeEmailInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendEmailSecureContactCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendEmailSecureContactCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendEmailSecureContactCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendEmailSecureContactCode"), _class.prototype), _class);
export { SecureContactModalEnrollEmailComponent as default };